export default __webpack_public_path__ + "static/media/114-lake-waves.dd9739e5.jpeg";